"use strict";
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./models"));
__export(require("./features/comparison/comparisonEngine"));
__export(require("./features/window"));
__export(require("./domain"));
__export(require("./features/comparison"));
__export(require("./features/threshold"));
__export(require("./features/status"));
__export(require("./features/metricValue"));
__export(require("./formatting/subtitles"));
var engine_1 = require("./engine");
exports.mapRolesToValues = engine_1.mapRolesToValues;
exports.getLatestValue = engine_1.getLatestValue;
exports.parseDateTrunc = engine_1.parseDateTrunc;
exports.getComparisonDateRange = engine_1.getComparisonDateRange;
var dateUtils_1 = require("./dateUtils");
exports.getDateRange = dateUtils_1.getDateRange;
var hitMapCalculator_1 = require("./hitMapCalculator");
exports.calculateHitMaps = hitMapCalculator_1.calculateHitMaps;
var numberFormatter_1 = require("./formatting/numberFormatter");
exports.formatAbsoluteValue = numberFormatter_1.formatAbsoluteValue;
exports.formatPillValue = numberFormatter_1.formatPillValue;
exports.formatValueAsMetricNumber = numberFormatter_1.formatValueAsMetricNumber;
exports.formatValueAsRelativeNumber = numberFormatter_1.formatValueAsRelativeNumber;
exports.formatValueAsRelativePercentage = numberFormatter_1.formatValueAsRelativePercentage;
exports.formatValueAsUnsignedPercentage = numberFormatter_1.formatValueAsUnsignedPercentage;
var deltaFormatter_1 = require("./formatting/deltaFormatter");
exports.formatComparisonTextForDetail = deltaFormatter_1.formatComparisonTextForDetail;
exports.formatComparisonTextForCard = deltaFormatter_1.formatComparisonTextForCard;
var localization_1 = require("./localization");
exports.setEngineLocale = localization_1.setEngineLocale;
var dateFormatter_1 = require("./formatting/dateFormatter");
exports.dateFormatterFactory = dateFormatter_1.dateFormatterFactory;
var parseDataPoints_1 = require("./parseDataPoints");
exports.parseDataPoints = parseDataPoints_1.parseDataPoints;
exports.parseResponse = parseDataPoints_1.parseResponse;
exports.validDateOrUndefined = parseDataPoints_1.validDateOrUndefined;
var symbolForDelta_1 = require("./formatting/symbolForDelta");
exports.symbolForDelta = symbolForDelta_1.symbolForDelta;
var formatParser_1 = require("./formatting/formatParser");
exports.isPercentageFormat = formatParser_1.isPercentageFormat;
exports.maxPrecision = formatParser_1.maxPrecision;
var materializeTable_1 = require("./transforms/materializeTable");
exports.materializeTable = materializeTable_1.materializeTable;
var utils_1 = require("./utils");
exports.testEffectiveDefinition = utils_1.testEffectiveDefinition;
var DefinitionBuilder_1 = require("./DefinitionBuilder");
exports.DefinitionBuilder = DefinitionBuilder_1.DefinitionBuilder;
exports.simpleDefinition = DefinitionBuilder_1.simpleDefinition;
var DataPointsQuery_1 = require("./transforms/DataPointsQuery");
exports.DataPointsQuery = DataPointsQuery_1.DataPointsQuery;
__export(require("./features/threshold/extendThroughRightMargin"));
__export(require("./componentModels/CardModel"));
__export(require("./componentModels/StatusIndicatorBarModel"));
__export(require("./componentModels/FeatureFlags"));
//# sourceMappingURL=MetricsEngine.js.map